<!--
 * @Description: 前场日志
 * @Author: wangwangwang
 * @Date: 2020-09-21 14:09:06
 * @LastEditors: hexy
 * @LastEditTime: 2023-12-21 10:33:30
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main style="display: flex">
        <div>
          <div class="header_right" @click="showCardNav = !showCardNav">
            <div class="title">搜索</div>
            <div>
              <transition name="from"></transition>
              <span v-show="!showCardNav">
                <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
              </span>
              <transition name="to"></transition>
              <span v-show="showCardNav">
                <i style="margin-right: 5px" class="el-icon-arrow-up"></i>
              </span>
            </div>
          </div>
          <div v-show="showCardNav" class="hr"></div>
          <el-collapse-transition>
            <div v-show="showCardNav">
              <div class="search">
                <span style="display: inline-block;margin-bottom: 10px;">
                  <span style="margin-right: 12px">工程名称</span>
                  <el-input v-model="tableParam.engineeringName" style="width: 240px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
                </span>
                <span style="display: inline-block;margin-left: 24px">
                  <span style="margin-right: 12px">订单号</span>
                  <el-input v-model="tableParam.orderNo" style="width: 240px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
                </span>
                <span style="display: inline-block;margin-left: 24px">
                  <span style="margin-right: 12px">站点</span>
                  <el-select v-model="tableParam.stationId" placeholder="请选择" style="width: 120px" clearable>
                    <el-option v-for="(item, index) in stationList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </span>
                <span style="display: inline-block;margin-left: 24px">
                  <span style="margin-right: 12px">浇筑部位</span>
                  <el-input v-model="tableParam.structuralParts" style="width: 240px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
                </span>
                <span style="display: inline-block;margin-left: 24px">
                  <span style="margin-right: 12px">生产时间</span>
                  <el-date-picker v-model="timeList" style="width: 320px" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
                </span>
                <span style="display: inline-block;margin-left: 24px">
                  <span style="margin-right: 12px">前场工长</span>
                  <el-input v-model="tableParam.foreMan" style="width: 240px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
                </span>
                <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="(tableParam.page = 1), gettableData()">查 询</el-button>
                <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
                <el-button size="medium" class="bottom_four" style="margin-left: 12px" @click="$Download(DownloadURL,tableParam,'前场日志.xls');">导 出</el-button>
              </div>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <div class="card" style="padding-top:10px">
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark">
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width">
                    <template slot-scope="scope">
                      <span v-if="item.label == '交付现场'">
                        <el-button v-if="scope.row.makeOpenStatus" size="mini" :class="'bottom_one'" @click="open('dialog1',scope.row)">查看</el-button>
                        <el-link v-else :underline="false" type="danger">未填写</el-link>
                        <!-- <el-button v-else size="mini" :class="'bottom_one'" @click="open('dialog1',scope.row)">未填写</el-button> -->
                      </span>
                      <span v-else-if="item.label == '前场工长'">
                        <span>{{scope.row.foreMan}}</span>
                      </span>
                      <span v-else-if="item.label == '交付质量控制'">
                        <el-button v-if="scope.row.makeCloseStatus" size="mini" :class="'bottom_one'" @click="open('dialog2',scope.row)">查看</el-button>
                        <el-link v-else :underline="false" type="danger">未填写</el-link>
                      </span>
                      <span v-else-if="item.prop == 'pouringMethod'">
                        {{JSON.parse(scope.row.pouringMethod).map(item => item.name).join(',')}}
                      </span>
                      <span v-else-if="item.prop == ''">
                        <el-button v-if="scope.row.makeRoadworkStatus" size="mini" :class="'bottom_one'" @click="open('dialog3',scope.row)">查看</el-button>
                        <el-link v-else :underline="false" type="danger">未填写</el-link>
                      </span>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize" :page-sizes="[10, 20, 30, 40,50,100,200,500,1000]" layout="prev,pager,sizes,next,jumper" :total="total" @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 交付现场 -->
    <el-dialog :visible.sync="dialog1"  width="980px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">交付现场</span>
      <div class="dialoginfo">
        <el-form :inline="true" label-width="150px" label-position="left">
          <el-form-item label="工程名称:">
            <div style="width:290px">{{from1.name}}</div>
          </el-form-item>
          <el-form-item label="浇筑部位:">
            <div style="width:290px">{{from1.structuralParts}}</div>
          </el-form-item>
          <el-form-item label="供应站点:">
            <div style="width:290px">{{from1.stationName}}</div>
          </el-form-item>
          <el-form-item label="汇报人:">
            <div v-if="!from1.createUserName" style="width:290px">{{userinfo.userRealName}}</div>
            <div v-else style="width:290px">{{from1.createUserName}}</div>
          </el-form-item>
          <el-form-item label="汇报时间：">
            <div v-if="from1.createTime" style="width:290px">{{from1.createTime}}</div>
            <div v-else style="width:290px">{{"----"}}</div>
          </el-form-item>
          <el-form-item label="开盘时间：">
            <div style="width:290px">{{from1.openTime}}</div>
          </el-form-item>
          <el-form-item label="收盘时间：">
            <div style="width:290px">{{from1.closingTime}}</div>
          </el-form-item>
          <el-form-item label="浇筑方量：">
            <div style="width:290px">{{from1.pouringNum}}</div>
          </el-form-item>
          <el-form-item label="施工现场道路：">
            <div style="width:290px">{{from1.constructionSiteRoads}}</div>
          </el-form-item>
          <el-form-item label="泵管架设情况:">
            <div style="width:290px">{{from1.pumpPipesInstallation}}</div>
          </el-form-item>
          <el-form-item label="泵管覆盖情况:">
            <div style="width:290px">{{from1.pumpPipeCover}}</div>
          </el-form-item>
          <el-form-item label="泵机文明形象:">
            <div style="width:290px">{{from1.pumpMachineCivilizedImage}}</div>
          </el-form-item>
          <el-form-item label="泵工、驾驶员劳保用品佩戴:">
            <div style="width:290px">{{from1.suppliesCarrying}}</div>
          </el-form-item>
          <el-form-item label="泵电缆线接线情况:">
            <div style="width:290px">{{from1.wiringSituation}}</div>
          </el-form-item>
          <el-form-item label="运输标识标牌:">
            <div style="width:290px">{{from1.transportSignage}}</div>
          </el-form-item>
          <el-form-item label="场内驾驶无超速情况:">
            <div style="width:290px">{{from1.overspeedSituation}}</div>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="from1.remark" style="width: 650px;" type="textarea" :rows="5" resize="none" placeholder="请输入" disabled></el-input>
          </el-form-item>
          <el-form-item label="图片：" label-width="90px">
          </el-form-item>
        </el-form>
        <div v-if="from1.imgs">
          <el-image 
            v-for="(item, index) in from1.imgs.split(',')" 
            :key="index" 
            style="width: 200px; height:200px;margin:0 10px 10px 10px;border-radius: 4px;" 
            :src="'/file'+item" 
            :preview-src-list="from1.imgs.split(',').map(item => '/file'+item)"
            :z-index="10000">
         </el-image>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="dialog1=false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 交付质量控制 -->
    <el-dialog v-dialogDrag :visible.sync="dialog2" width="1000px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">交付质量控制</span>
      <div class="dialoginfo">
        <el-form :inline="true" label-width="160px" label-position="left">
          <el-form-item label="工程名称：">
            <div style="width:290px">{{from2.name}}</div>
          </el-form-item>
          <el-form-item label="浇筑部位:">
            <div style="width:290px">{{from2.structuralParts}}</div>
          </el-form-item>
          <el-form-item label="供应站点:">
            <div style="width:290px">{{from2.stationName}}</div>
          </el-form-item>
          <el-form-item label="汇报人：">
            <div v-if="!from2.createUserName" style="width:290px">{{userinfo.userRealName}}</div>
            <div v-else style="width:290px">{{from2.createUserName}}</div>
          </el-form-item>
          <el-form-item label="汇报时间：">
            <div v-if="from2.createTime" style="width:290px">{{from2.createTime}}</div>
            <div v-else style="width:290px">{{"----"}}</div>
          </el-form-item>
          <el-form-item label="浇筑标号核对情况:">
            <div style="width:290px">{{from2.labelVerificationStatus}}</div>
          </el-form-item>
          <el-form-item label="浇筑标号核对情况图片:" label-width="220px"></el-form-item>
          <div v-if="from2.labelVerificationStatusImage">
            <el-image 
            v-for="(item, index) in from2.labelVerificationStatusImage.split(',')" 
            :key="index" style="width: 200px; height:200px;margin:0 10px 10px 10px;border-radius: 4px;" 
            :src="'/file'+item" 
            :preview-src-list="from2.labelVerificationStatusImage.split(',').map(item => '/file'+item)" 
            :z-index="10000">
          </el-image>
          </div>
          <el-form-item label="高低标号转换处置情况:">
            <div style="width:290px">{{from2.labelConversionSituation}}</div>
          </el-form-item>
          <el-form-item label="润泵水、砂浆、洗泵水去向:">
            <div style="width:290px">{{from2.specialProductsDestination}}</div>
          </el-form-item>
          <el-form-item label="砼和易性情况/异常处置情况:">
            <div style="width:290px">{{from2.abnormalHandlingSituation}}</div>
          </el-form-item>
          <el-form-item label="砼覆盖/养护情况:">
            <div style="width:290px">{{from2.maintenanceSituation}}</div>
          </el-form-item>
          <el-form-item label="砼覆盖/养护情况图片:" label-width="220px"></el-form-item>
          <div v-if="from2.maintenanceSituationImage">
            <el-image 
              v-for="(item, index) in from2.maintenanceSituationImage.split(',')" 
              :key="index" style="width: 200px; height:200px;margin:0 10px 10px 10px;border-radius: 4px;" 
              :src="'/file'+item" 
              :preview-src-list="from2.maintenanceSituationImage.split(',').map(item => '/file'+item)" 
              :z-index="10000"
            >
            </el-image>
          </div>
          <el-form-item label="备注">
            <el-input v-model="from2.remark" style="width: 700px;" type="textarea" :rows="5" resize="none" placeholder="请输入" disabled></el-input>
          </el-form-item>
          <el-form-item label="图片：" label-width="90px"></el-form-item>
          <div v-if="from2.imgs">
            <el-image 
              v-for="(item, index) in from2.imgs.split(',')" 
              :key="index" style="width: 200px; height:200px;margin:0 10px 10px 10px;border-radius: 4px;" 
              :src="'/file'+item" 
              :preview-src-list="from2.imgs.split(',').map(item => '/file'+item)" 
              :z-index="10000" 
            >
          </el-image>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="dialog2=false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 交付签收 -->
    <el-dialog v-dialogDrag :visible.sync="dialog3" width="1000px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">交付签收</span>
      <div class="dialoginfo">
        <el-form :inline="true" label-width="160px" label-position="left">
          <el-form-item label="工程名称：">
            <div style="width:290px">{{from3.name}}</div>
          </el-form-item>
          <el-form-item label="浇筑部位:">
            <div style="width:290px">{{from3.structuralParts}}</div>
          </el-form-item>
          <el-form-item label="供应站点:">
            <div style="width:290px">{{from3.stationName}}</div>
          </el-form-item>
          <el-form-item label="汇报人：">
            <div v-if="!from3.createUserName" style="width:290px">{{userinfo.userRealName}}</div>
            <div v-else style="width:290px">{{from3.createUserName}}</div>
          </el-form-item>
          <el-form-item label="汇报时间：">
            <div v-if="from3.createTime" style="width:290px">{{from3.createTime}}</div>
            <div v-else style="width:290px">{{"----"}}</div>
          </el-form-item>
          <el-form-item label="供货小票签收情况:">
            <div style="width:290px">{{from3.receiptSignSituation}}</div>
          </el-form-item>
          <el-form-item label="过磅异常及处置情况:">
            <div style="width:290px">{{from3.abnormalHandlingSituation}}</div>
          </el-form-item>
          <el-form-item label="爆模、报废砼、签证情况:">
            <div style="width:290px">{{from3.visaSituation}}</div>
          </el-form-item>
          <el-form-item label="量差及原因:">
            <div style="width:290px">{{from3.quantityDifferenceReasons}}</div>
          </el-form-item>
          <el-form-item label="尾料及去向情况:">
            <div style="width:290px">{{from3.tailingsDirection}}</div>
          </el-form-item>
          <el-form-item label="其他异常情况:">
            <div style="width:290px">{{from3.otherAbnormalSituations}}</div>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="from3.remark" style="width: 700px;" type="textarea" :rows="5" resize="none" placeholder="请输入" disabled></el-input>
          </el-form-item>
          <el-form-item label="图片：" label-width="90px"></el-form-item>
          <div v-if="from3.imgs">
            <el-image 
            v-for="(item, index) in from3.imgs.split(',')" 
            :key="index" style="width: 200px; height:200px;margin:0 10px 10px 10px;border-radius: 4px;" 
            :src="'/file'+item" 
            :preview-src-list="from3.imgs.split(',').map(item => '/file'+item)" 
            :z-index="10000"
            >
          </el-image>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="dialog3=false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {getUserAutList} from "@/api/common.js";
import mixin from "@/mixins/ICPSmixin.js";
import { queryPage, opening, closing, getListByPlanId,Download} from "@/api/smart/schedul/frontLog.js";
import { getUserInfo } from "@/utils/auth.js";
export default {
  mixins: [mixin],
  data() {
    return {
      timeList:[new Date().Format("yyyy-MM-dd 00:00:00"), new Date().Format("yyyy-MM-dd 23:59:59")],
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      DownloadURL: Download,
      imgsText: '',
      imgList: [],
      mp4List: [],
      fileList: [],
      stationList:[],//站点
      /*表格数据*/
      table: [
        { label: "工程名称", width: "auto", prop: "engineeringName", status: true,},
        { label: "订单编号", width: "auto", prop: "orderNo", status: true },
        { label: "浇筑部位", width: "auto", prop: "structuralParts", status: true,},
        { label: "值班前场", width: "auto", prop: "foreMan", status: true },
        { label: "责任前场", width: "auto", prop: "dutyForeman", status: true },
        { label: "生产时间", width: "auto", prop: "pouringTime", status: true },
        { label: "产品名称", width: "auto", prop: "productName", status: true },
        { label: "浇筑方式", width: "auto", prop: "pouringMethod", status: true },
        { label: "浇筑方量", width: "auto", prop: "pouringNum", status: true },
        { label: "交付现场", width: "120", prop: "", status: true },
        { label: "交付质量控制", width: "120", prop: "", status: true },
        { label: "交付签收", width: "120", prop: "", status: true },
      ],
      pagesType: 0,
      /*添加表单数据*/
      rules: {
        code: [{ required: true, message: "请输入站点编码", trigger: "blur" }],
      },
      fromDate: {
        code: "",
      },
      low: "",
      /*交付现场*/
      dialog1: false,
      from1: {},
      /*交付质量控制*/
      dialog2: false,
      from2: {},
      from3:{},
      /*交付签收*/
      dialog3: false,
      imgsDialog: false,
      userinfo: getUserInfo(),
    };
  },
  watch: {
    timeList(val) {
      if (val?.length > 0) {
        this.tableParam.startDate = val[0];
        this.tableParam.endDate = val[1];
      } else {
        this.tableParam.startDate = "";
        this.tableParam.endDate = "";
      }
    },
  },
  async created() {
    this.tableParam = {
      ...this.tableParam,
      engineeringName: "",
      contractNo: "",
      stationId:"",
      userStationId:"",
      foreMan:"",
      structuralParts:"",
    };
    this.tableParam.userStationId = this.userinfo.pointIds[0]
    this.tableParam.startDate = this.timeList[0] || "";
    this.tableParam.endDate = this.timeList[1] || "";
    this.gettableData();
    this.stationList = await getUserAutList(true);
  },
  methods: {
    /*重置数据*/
    init() {
      this.tableParam.structuralParts = "";
      this.tableParam.foreMan = "";
      this.tableParam.engineeringName = "";
      this.tableParam.contractNo = "";
      this.tableParam.stationId = "";
      this.tableParam.userStationId = this.userinfo.pointIds[0]
      this.gettableData();
    },
    open(key, low) {
      this.low = low;
      console.log(low)
      if (key == "dialog1") {
        opening({ planId: low.planId,forManId:low.foreManId }).then((res) => {
          this.from1 = { ...this.from1,...low, ...res.data };
        });
      }
      if (key == "dialog2") {
        closing({ planId: low.planId,forManId:low.foreManId }).then((res) => {
          this.from2 = { ...this.from2,...low, ...res.data };
        });
      }
      if (key == "dialog3") {
        getListByPlanId({ planId: low.planId,forManId:low.foreManId }).then((res) => {
          this.from3 = { ...this.from3,...low, ...res.data };
        });
      }
      this[key] = true;
    },
    // open1(row) {
    //   const files = row.imgs;
    //   let items = files ?.split(",").map(res => ('/file/' + res))
    //   this.imgList = items.filter(res => (res.includes('type=img')))
    //   console.log(this.imgList)
    //   this.mp4List = items.filter(res => (res.includes('type=mp4')))
    //   this.fileList = items.filter(res => (res.includes('type=file')))
    //   // this.imgsDialog = true
    // },
    reset(key) {
      this[key] = false;
    },
    pagessubmitFromDate() {
      let _this = this;
      _this.$refs.reffromDate.validate((valid) => {
        if (valid) {
          _this.submitFromDate();
        } else {
          return false;
        }
      });
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}
/*
 <el-link class="table_link" :underline="false">查看配合比</el-link>*/
.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}
</style>
